


















import { Component, Prop, Vue } from 'vue-property-decorator';
import SelectField from '@/components/form/SelectField.vue';
import CommuneProjection from '@/types/projections/CommuneProjection';
import Loader from '@/components/Loader.vue';

@Component({
  components: { SelectField, Loader },
})
export default class BookingCommuneSelect extends Vue {
  @Prop([String, Number])
  public value!: string | number;

  public identifier: string = 'commune-select';

  @Prop(Array)
  public communes!: CommuneProjection[];

  @Prop(Number)
  public communeId!: number;
}
